import i18nInstance from 'i18n/i18nInstance'
import type { Section } from '@mc/faq'
import type { FreeTrial, NoFreeTrial } from '@mc/free-trial'
import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { paths } from '@mc/paths'
import { CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE } from 'experiments/pen-5840_v1_core_membership_language_cleanup'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetGuestPassSectionProps = {
  trial: FreeTrial | NoFreeTrial
  isLanguageCleanupVariant?: boolean // pen-5840_v1_core_membership_language_cleanup
}

export const getGuestPassSection: (
  props: GetGuestPassSectionProps,
) => Section = ({
  trial,
  isLanguageCleanupVariant, // pen-5840_v1_core_membership_language_cleanup
}: GetGuestPassSectionProps) => ({
  title: t('faq.guestPass.title'),
  questions: [
    {
      uuid: 'faq.guestPass.question1',
      title: t('faq.guestPass.question1'),
      answer: (
        <Trans
          i18nKey='faq.guestPass.answer1'
          values={{
            duration: trial.strings.duration,
            instructorCount: getNumberOfInstructors(),
          }}
          ns={
            isLanguageCleanupVariant
              ? CORE_MEMBERSHIP_LANGUAGE_CLEANUP_I18N_NAMESPACE
              : '@mc/next'
          }
        >
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      uuid: 'faq.guestPass.question2',
      title: t('faq.guestPass.question2'),
      answer: (
        <Trans i18nKey='faq.guestPass.answer2' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted'>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a
              href={paths.guestPassTermsPath}
              className='mc-text--link'
              target='_blank'
              rel='noopener noreferrer'
              data-testid='guest-pass-terms-link'
            />
          </p>
        </Trans>
      ),
    },
  ],
})
